import { Spin } from "antd";
import React, { Suspense, useEffect } from "react";
import { HashRouter,  useRoutes } from "react-router-dom";
import publicRoutes from "./Routes/PublicRoutes";
import privateAdminRoute from "./Routes/PrivateRoutes";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainerMsg, removeLocalStorageItem } from "./utils";
import useDigiLoader from "./Hooks/useDigiLoader";

function App() {
  const userRouting = [...publicRoutes(), ...privateAdminRoute()];
  const UserRouteConfig = () => useRoutes(userRouting);
  const loader = useDigiLoader();
  useEffect(() => {
    if (loader === "2") {
      removeLocalStorageItem("startLoader");
    }
    return () => removeLocalStorageItem("startLoader");
  }, [loader]);
  return (
    <>
      <HashRouter>
        <Spin spinning={loader === "1"}>
        <Suspense
        fallback={
          <div className="Spinner">
            <Spin size="default" />
            <p>Loading Page...</p>
          </div>
        }
      >
        <UserRouteConfig />
      </Suspense>
        </Spin>
      </HashRouter>
      <ToastContainerMsg />
    </>
  );
}

export default App;
